import { render, staticRenderFns } from "./CoreButton.vue?vue&type=template&id=1eb18824&scoped=true"
import script from "./CoreButton.vue?vue&type=script&lang=js"
export * from "./CoreButton.vue?vue&type=script&lang=js"
import style0 from "./CoreButton.vue?vue&type=style&index=0&id=1eb18824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb18824",
  null
  
)

export default component.exports